import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
export function App() {
  // Optimizaciones de rendimiento críticas para Core Web Vitals
  useEffect(() => {
    // Evitar inyecciones duplicadas causadas por React StrictMode
    if (document.getElementById('opt-fonts-loaded')) return;
    const headElements: HTMLElement[] = [];
    // 1. Preconnect a Google Fonts (Solo los necesarios para evitar advertencias de exceso)
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://fonts.googleapis.com';
    preconnect1.id = 'opt-pre-1';
    headElements.push(preconnect1);
    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://fonts.gstatic.com';
    preconnect2.crossOrigin = 'anonymous';
    preconnect2.id = 'opt-pre-2';
    headElements.push(preconnect2);
    // 2. Carga asíncrona real de fuentes (Técnica media="print")
    // Esto garantiza que el CSS de las fuentes NO bloquee el renderizado inicial
    const fontStylesheet = document.createElement('link');
    fontStylesheet.rel = 'stylesheet';
    fontStylesheet.href = 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,800;1,400&display=swap';
    fontStylesheet.media = 'print'; // Carga en segundo plano
    fontStylesheet.onload = function () {
      ;
      (this as HTMLLinkElement).media = 'all'; // Aplica los estilos una vez cargados
    };
    fontStylesheet.id = 'opt-fonts-loaded';
    headElements.push(fontStylesheet);
    // 3. Preload de la imagen LCP
    const preloadImage = document.createElement('link');
    preloadImage.rel = 'preload';
    preloadImage.as = 'image';
    preloadImage.href = 'https://cdn.magicpatterns.com/uploads/oUJSErHXHAdXdTZha8jGGh/hf_20260329_010749_655a106a-de3d-4913-ae78-f3f5dff8f196.png';
    preloadImage.fetchPriority = 'high';
    preloadImage.id = 'opt-preload-img';
    headElements.push(preloadImage);
    // Inyectar elementos
    headElements.forEach(el => document.head.appendChild(el));
    // Inyectar Meta Pixel Script
    if (!document.getElementById('meta-pixel-script')) {
      const pixelScript = document.createElement('script');
      pixelScript.id = 'meta-pixel-script';
      pixelScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1468877027936479');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(pixelScript);
    }
    // Nota: No removemos los elementos en el cleanup para que la caché del navegador
    // y la carga asíncrona no se interrumpan si el componente se remonta rápidamente.
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1468877027936479&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>
      <SalesPage data-id="element-2" />
    </>;
}